import { FIELD_TYPES } from "constants/template-field-type";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import FullParagraphFieldConfig from "segments/desktop/core-components/full-paragraph/fields-config";

const { ...restOfTitleConfig } = TitleConfig;
const { ...restOfParagraphConfig } = ParagraphConfig;
const {
  textAlign,
  mobileTextAlign,
  textColor,
  topic,
  buttonConfig: button,
  ...restFullParagraphFieldsConfig
} = FullParagraphFieldConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Tags By Product",
  fields: {
    ...ThemeConfig,
    fullParagraph: {
      type: FIELD_TYPES.NESTED,
      label: "Full paragraph",
      fields: restFullParagraphFieldsConfig
    },
    subTitle: {
      type: FIELD_TYPES.NESTED,
      label: "Sub title",
      fields: TitleConfig
    },
    tabsPaddingTop: {
      type: FIELD_TYPES.TEXT,
      label: "Tabs padding top"
    },
    tabs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
          title: {
            type: FIELD_TYPES.NESTED,
            label: "Tab title",
            fields: {
              productImage: { type: FIELD_TYPES.GALLERY, label: "Product logo image" },
              selectedProductImage: { type: FIELD_TYPES.GALLERY, label: "Selected product logo image" },
              ...restOfTitleConfig,
              ...restOfParagraphConfig
            }
          },
          tabContent: {
            type: FIELD_TYPES.NESTED,
            label: "Tab content",
            fields: {
              clusters: {
                type: FIELD_TYPES.MULTIPLE_NESTED,
                label: "Clusters",
                maxLimit: 9,
                nestedConfig: {
                  type: FIELD_TYPES.NESTED,
                  fields: {
                    text: { type: FIELD_TYPES.TEXT, label: "Text", translatable: true },
                    image: { type: FIELD_TYPES.GALLERY, label: "Image" },
                    colorName: { type: FIELD_TYPES.COLOR_PICKER, label: "Color" },
                    clusterId: {
                      type: FIELD_TYPES.CLUSTERS,
                      label: "Cluster Id"
                    },
                    useCaseId: {
                      type: FIELD_TYPES.SUB_CLUSTERS,
                      label: "Usecase Id"
                    },
                    initiallySelected: { type: FIELD_TYPES.BOOLEAN, label: "Initially selected" }
                  }
                }
              }
            }
          }
        }
      }
    },
    progressbarColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Progress Bar Color" }
  }
};
